import axios from "axios";
import {
  getAccessToken,
  getRefreshToken,
  setAccessToken,
  removeAccessToken,
  removeRefreshToken,
} from "../utils/tokenService";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

apiClient.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Set Content-Type dynamically for file uploads
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Skip interceptor for login requests
    if (originalRequest.url.includes("/login")) {
      return Promise.reject(error);
    }

    // **ONLY handle 401 token refresh - NO network retries**
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = getRefreshToken();
      if (refreshToken) {
        try {
          const { data } = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/admin/refresh`,
            { refreshToken },
            { headers: { "Content-Type": "application/json" } }
          );

          setAccessToken(data.accessToken);
          originalRequest.headers.Authorization = `Bearer ${data.accessToken}`;
          return apiClient(originalRequest);
        } catch {
          removeAccessToken();
          removeRefreshToken();
          window.location.href = "/login";
        }
      } else {
        removeAccessToken();
        removeRefreshToken();
        window.location.href = "/login";
      }
    }

    // **For all other errors (including network errors): reject immediately**
    return Promise.reject(error);
  }
);

export default apiClient;
